import { render, staticRenderFns } from "./GroupShiftTasksModal.vue?vue&type=template&id=4cde5297&scoped=true"
import script from "./GroupShiftTasksModal.vue?vue&type=script&lang=js"
export * from "./GroupShiftTasksModal.vue?vue&type=script&lang=js"
import style0 from "./GroupShiftTasksModal.vue?vue&type=style&index=0&id=4cde5297&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cde5297",
  null
  
)

export default component.exports